import dklogo from "../../img/PCLC.svg";
import {Link} from 'react-router-dom';

const PasswordRecovery = () => {
    return (
        <div className="auth-card">
            <img src={dklogo} alt="PalCare Logo" className="auth-card__logo" />
            <div className="auth-card__icon">
                <i className="fe fe-lock" />
            </div>
            <h2 className="auth-card__title">Password Recovery</h2>
            <p className="auth-card__message">
                Please contact your administrator for password recovery.
                For admin account recovery, contact support at{' '}
                <strong>920-694-0085</strong>
            </p>
            <Link to="/" className="auth-link">Back to Login</Link>
        </div>
    );
};

export default PasswordRecovery;
